import { AppointmentCancelForm } from './appointment_cancel_form/appointment_cancel_form';
import { AppointmentDetails } from './appointment_details/appointment_details';
import { AppointmentFooterButtonController } from './appointment_footer_button/appointment_footer_button';
import { AppointmentRequest } from './appointment_request/appointment_request';
import { MyAppointmentsContoller } from './my_appointments/my_appointments';

angular
  .module('capability-ng-appointments')
  .controller('ngMyAppointmentsContoller', MyAppointmentsContoller)
  .component('myAppointments', {
    controller: MyAppointmentsContoller,
    templateUrl: 'capability-ng-appointments/src/components/my_appointments/my_appointments.html'
  })
  .controller('ngAppointmentDetails', AppointmentDetails)
  .component('appointmentDetails', {
    controller: AppointmentDetails,
    templateUrl: 'capability-ng-appointments/src/components/appointment_details/appointment_details.html'
  })
  .component('appointmentDetailsHeader', {
    templateUrl: 'capability-ng-appointments/src/components/appointment_details_header/appointment_details_header.html'
  })
  .component('appointmentCancelForm', {
    bindings: {
      appointment: '<',
      closeCancelForm: '&',
      onCancel: '&'
    },
    controller: AppointmentCancelForm,
    templateUrl: 'capability-ng-appointments/src/components/appointment_cancel_form/appointment_cancel_form.html'
  })
  .component('appointmentRequest', {
    controller: AppointmentRequest,
    templateUrl: 'capability-ng-appointments/src/components/appointment_request/appointment_request.html'
  })
  .component('appointmentRequestHeader', {
    templateUrl: 'capability-ng-appointments/src/components/appointment_request_header/appointment_request_header.html'
  })
  .component('confettiIcon', {
    templateUrl: 'capability-ng-appointments/src/components/confetti/confetti.html'
  })
  .controller('AppointmentFooterButtonController', AppointmentFooterButtonController)
  .component('appointmentFooterButton', {
    controller: AppointmentFooterButtonController,
    templateUrl: 'capability-ng-appointments/src/components/appointment_footer_button/appointment_footer_button.html'
  });

export * from './choice_selector/choice_selector';
export * from './appointment_cancel_form/appointment_cancel_form';
export * from './appointment_details/appointment_details';
export * from './my_appointments/my_appointments';
export * from './appointment_request/appointment_request';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/components_module.ts